import { signOut } from 'firebase/auth';
import { auth } from '../../firebase-config';
import { CLIENT_LOGIN_PATH } from '../../config/clientAccess';
import ClientDashboardLayout from '../ClientPortal/ClientDashboardLayout';
import './MotoWebDashboard.css';

const POWERBI_MOTOWEB_URL = 'https://app.powerbi.com/view?r=eyJrIjoiYmY2NTkwNGUtNzMzYS00NjdjLWFkOWEtNDgwNjJmOGUxYWJiIiwidCI6ImQyODAxN2UzLWRlYTMtNDhlNC1hYzdmLTAwYWYyY2QxNjQ0YiJ9';

const MotoWebDashboard = ({ user }) => {
  const handleLogout = async () => {
    try {
      await signOut(auth);
      window.location.replace(CLIENT_LOGIN_PATH);
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  const hasPowerBiReport = POWERBI_MOTOWEB_URL !== 'PENDIENTE_DE_INSERTAR';

  return (
    <ClientDashboardLayout
      clientName="MotoWeb Las Palmas"
      subtitle="Rendimiento orgánico y analítica de contenidos"
      user={user}
      onLogout={handleLogout}
      reportLabel="Dashboard de rendimiento de MotoWeb Las Palmas"
    >
      {hasPowerBiReport ? (
        // Firebase protege el acceso visual al portal. La privacidad real del
        // informe depende de usar Power BI secure embed o Power BI Embedded;
        // una URL de "Publish to web" nunca debe considerarse privada.
        <iframe
          title="Dashboard de Power BI de MotoWeb Las Palmas"
          src={POWERBI_MOTOWEB_URL}
          allowFullScreen
        />
      ) : (
        <div className="motoweb-report-placeholder">
          <div className="motoweb-chart-icon" aria-hidden="true">
            <span /><span /><span />
          </div>
          <h3>Informe de Power BI pendiente</h3>
          <p>Este espacio mostrará el dashboard cuando finalice su configuración segura.</p>
        </div>
      )}
    </ClientDashboardLayout>
  );
};

export default MotoWebDashboard;
